<template>
  <div>
    <div class="screen-box">
      <van-cell
        :class="['date-cell', period ? 'active-date-cell' : '']"
        is-link
        :value="period ? `${year}年${period}期` : '请选择'"
        arrow-direction="down"
        @click="openPeriodPopup"
      />
      <div
        :class="['choiceness-btn', isSelected ? 'choiceness-active-btn' : '']"
        @click="toScreenSelected"
      >
        精选论文
      </div>
      <van-popup
        v-model="dateShow"
        :safe-area-inset-bottom="true"
        :close-on-click-overlay="false"
        round
        position="bottom"
      >
        <div class="date-popup-top">
          <span @click="dateShow = false">取消</span>
          <span @click="toScreenPeriod">确定</span>
        </div>
        <van-index-bar class="date-popup-select" :index-list="indexList">
          <div class="date-popup-select-content">
            <div v-for="item in periodList" :key="item.journalsYear">
              <van-index-anchor
                class="date-popup-select-point"
                :index="item.journalsYear"
                >{{ item.journalsYear }}</van-index-anchor
              >
              <div class="date-popup-select-box">
                <span
                  :class="[
                    'date-popup-select-item',
                    yearsPeriod === `${i.journalsYear}-${i.journalsTerm}`
                      ? 'date-popup-select-item-active'
                      : '',
                  ]"
                  v-for="i in item.journalsTermList"
                  :key="i.journalsTerm"
                  @click="toSelectPeriod(i.journalsYear, i.journalsTerm, i)"
                  >{{ i.journalsTerm }}期</span
                >
              </div>
            </div>
          </div>
        </van-index-bar>
      </van-popup>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :immediate-check="false"
      :finished-text="articleList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="lv-list" v-if="loading || articleList.length > 0">
        <LvItem
          class="lv-list-item"
          v-for="(item, index) in articleList"
          :key="index"
          :type="item.type"
          :title="item.title"
          :artSummary="item.artSummary"
          :author="item.firstAuthor"
          :otherAuthor="`${(item.articleAuthorList || []).map(i=>i.authorName).join(',')}`"
          :periodicalName="item.periodical"
          :periodicalTime="item.type === 1 ? item.mettingTime : item.timeStr"
          @click.native="toDetail(item.articleType, item.articleId)"
        />
      </div>
      <noneList :noneType="noneType" v-else />
    </van-list>
  </div>
</template>

<script>
import LvItem from "@/views/mobileView/components/listItem/lvItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  name: "BkLvLsit",
  components: {
    LvItem,
    noneList,
  },
  props: {
    argumentObj: {
      // 文章类型参数
      type: Object,
      require: true,
    },
    listRequest: {
      // 获取文章调取接口方法
      type: Function,
      require: true,
    },
  },
  computed: {
    noneType() {
      if (this.articleList.length === 0) {
        if (this.periodList.length) {
          return "noIssue";
        } else {
          return "lvList";
        }
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      articleList: [], // 文章List
      params: {
        pageNo: 0,
        pageSize: 20,
      },
      loading: false,
      finished: false,
      error: false,
      dateShow: false,
      indexList: [],
      periodList: [],
      yearsPeriod: "",
      year: "",
      period: "",
      isSelected: false,
    };
  },
  filters: {
    typeFilter(type) {},
  },
  created() {
    this.getThesisPeriod();
  },
  methods: {
    toScreenSelected() {
      this.isSelected = !this.isSelected;
      this.params = {
        ...this.params,
        pageNo: 1,
        selected: this.isSelected,
      };
      this.getInformation();
    },
    toScreenPeriod() {
      if (this.yearsPeriod !== "") {
        this.year = this.yearsPeriod.split("-")[0];
        this.period = this.yearsPeriod.split("-")[1];
        this.params = {
          ...this.params,
          pageNo: 1,
          year: this.year,
          term: this.period,
        };
      } else {
        this.year = "";
        this.period = "";
        delete this.params.year;
        delete this.params.term;
      }
      this.dateShow = false;
      this.getInformation();
      this.$emit('onBkLvListChange', this.selectedIssue)
    },
    toSelectPeriod(year, period, i) {
      this.selectedIssue = i
      let selectText = `${year}-${period}`;
      if (this.yearsPeriod !== selectText) {
        this.yearsPeriod = selectText;
      } else {
        this.yearsPeriod = "";
      }
    },
    openPeriodPopup() {
      if (this.period) {
        this.yearsPeriod = `${this.year}-${this.period}`;
      }
      this.dateShow = true;
    },
    async getThesisPeriod() {
      this.loading = true;
      let res = await this.$apis.hundredServe.getBkThesisPeriod(
        this.$route.query.id
      );
      if (res.resultCode === "200") {
        if (res.data.length) {
          const firstTerm = res.data[0].journalsTermList[0];
          this.year = firstTerm.journalsYear;
          this.period = firstTerm.journalsTerm;
          this.params = {
            ...this.params,
            pageNo: 1,
            year: this.year,
            term: this.period,
          };
          this.indexList = res.data.map((item) => item.journalsYear);
          this.periodList = res.data;
          this.selectedIssue = res.data[0].journalsTermList[0]
          this.$emit('onBkLvListChange', this.selectedIssue)
          this.getInformation();
        } else {
          this.onLoad();
        }
      }
    },
    // 触底加载
    onLoad() {
      this.params.pageNo += 1;
      this.getInformation();
    },
    // 调取父组件获取文章列表接口方法
    async getInformation() {
      this.loading = true;
      let res = await this.listRequest({
        ...this.params,
        ...this.argumentObj,
      });
      if (res.isSuccess) {
        if (this.params.pageNo > 1) {
          this.articleList.push(...res.list);
        } else {
          this.articleList = res.list;
        }
        console.log('this.articleList', this.articleList)
        this.finished = res.list.length < 20;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 跳转文章详情页
    toDetail(type, id, goodsId, open) {
      let out = this.$route.query.out;
      this.$router.push({
        path: "thesisDetail",
        query: { type, id, out },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.screen-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .date-cell {
    padding: 0;
    width: unset;
    &::v-deep .van-cell__value {
      flex: none;
      color: #999;
    }
    &::after {
      display: none;
    }
  }
  .active-date-cell {
    &::v-deep .van-cell__value {
      flex: none;
      color: #333;
    }
  }
  .choiceness-btn {
    flex: none;
    padding: 5px 12px;
    color: #333;
    background-color: #f7f8fa;
    border-radius: 15px;
  }
  .choiceness-active-btn {
    background-color: #4a79f1;
    color: #fff;
  }
}
.date-popup-top {
  display: flex;
  justify-content: space-between;
  padding: 17px 24px;
  border-bottom: 1px solid #ededed;
  font-size: 16px;
  color: #333333;
}
.date-popup-select {
  display: flex;
  position: relative;
  width: 100%;
  height: 400px;
  overflow-y: auto;
  &::v-deep .van-index-bar__sidebar {
    top: unset;
    left: 0;
    width: 90px;
    height: 400px;
    overflow-y: auto;
    background-color: #f5f6f6;
    transform: none;
    .van-index-bar__index {
      padding: 12px 27px;
      font-size: 15px;
    }
    .van-index-bar__index--active {
      background-color: #fff;
      color: #4a79f1;
    }
  }
  .date-popup-select-content {
    padding-left: 110px;
    width: 100%;
    .date-popup-select-point {
      height: unset !important;
      &::v-deep .van-index-anchor {
        position: relative;
        left: 0 !important;
        transform: none !important;
        padding: 10px 0 15px;
        font-size: 15px;
        color: #333333;
        line-height: normal;
        &::after {
          display: none;
        }
      }
    }
    .date-popup-select-box {
      .date-popup-select-item {
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 10px;
        width: 75px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        background-color: #f5f5f5;
        border-radius: 18px;
        font-size: 13px;
        color: #333333;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
      .date-popup-select-item-active {
        background-color: #4a79f1;
        color: #fff;
      }
    }
  }
}
.lv-list {
  .lv-list-item {
    border-bottom: 1px solid #ededed;
  }

  .hy-list-item {
    margin-bottom: 13px;
    padding-bottom: 15px;
    width: 100%;
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid #ededed;
    overflow: hidden;
  }

  .ts-list-box {
    width: 100%;
    column-count: 2;
    column-gap: 1em;

    .ts-item {
      border: 1px solid #f1f1f1;
      box-sizing: border-box;
      -webkit-column-break-inside: avoid;
      break-inside: avoid;
      //   max-height: 200px;
      margin-bottom: 20px;
      width: 155px;
    }
  }

  .px-list-box {
    .px-list-item {
      display: inline-block;
      margin-top: 12px;
      margin-right: 10px;
      width: 150px;
      border: 1px solid #f1f1f1;
      border-radius: 6px;
      background-color: #fff;
      overflow: hidden;

      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }

  .bg-list-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .bg-item {
      margin-bottom: 12px;
      width: 156px;
      border-radius: 6px;
      border: 1px solid #f1f1f1;
      overflow: hidden;
    }
  }
}
</style>
